// check for beginning of epoch date/time values
export const isValidEpochDateTime = (value: string) => value !== '1970-01-01T00:00:00.000Z';
